/* eslint-disable camelcase */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-restricted-syntax */
/* eslint-disable max-len */
/* eslint-disable no-eval */
/* eslint-disable nordic/i18n-jsx-no-literals */
const React = require('react');
const { useEffect, useRef } = require('react');
const {
  useLiveDemoContext,
} = require('../base-live-demo-component/Provider/liveDemoContext');
const { checkoutProCreationScript } = require('./constants');
const PreferencesService = require('../../../../services/preferencesService');
const {
  users,
  getPaymentMethodsPayload,
} = require('../utils/utils');
const { useDebounce } = require('../utils/debounce');

const View = ({
  publicKey,
  theme,
  maxInstallments,
  showTitle = true,
  showPaymentButton = true,
  language,
  customVariables,
  customTexts,
  payerInfo,
  amount,
  paymentMethodCreditCardType,
  pix,
  bolbradesco,
  debit_card_caixa,
  debit_card,
  paymentMethodDebitCardType,
  efectivo,
  ticket,
  pagoefectivo_atm,
  bancaInternet,
  pec,
  bank_transfer,
  credit_card,
}) => {
  const { setBehaviorData, formData } = useLiveDemoContext();

  const debouncePaymentMethods = [
    useDebounce(paymentMethodCreditCardType, 2000),
    useDebounce(pix, 2000),
    useDebounce(bolbradesco, 2000),
    useDebounce(debit_card_caixa, 2000),
    useDebounce(debit_card, 2000),
    useDebounce(paymentMethodDebitCardType, 2000),
    useDebounce(efectivo, 2000),
    useDebounce(bank_transfer, 2000),
    useDebounce(ticket, 2000),
    useDebounce(pagoefectivo_atm, 2000),
    useDebounce(bancaInternet, 2000),
    useDebounce(pec, 2000),
    useDebounce(pagoefectivo_atm, 2000),
    useDebounce(credit_card, 2000),
  ];

  const iframeRef = useRef(null);

  useEffect(() => {
    const cachedPreferenceData = JSON.stringify(
      localStorage.getItem('cho-pro-preferenceData'),
    );

    let preferenceId = cachedPreferenceData?.id;

    const setCheckoutProPropsAndEval = (props, script, delay) => {
      window.checkoutProProps = props;

      setTimeout(() => {
        setBehaviorData((prev) => ({
          ...prev,
          showLayoutSpinner: false,
        }));
        window.eval(script);
      }, delay);
    };

    const { accessToken } = users.find((item) => item.user === publicKey);

    const createCheckoutProProps = () => ({
      publicKey: publicKey || 'TEST-de563cac-2acb-4ec6-b506-9fb302a2848d',
      preferenceId: preferenceId || '',
      language: language || 'pt-BR',
    });

    const customPreferenceData = {
      items: [
        {
          title: 'Dummy Title',
          description: 'Dummy description',
          picture_url: 'http://www.myapp.com/myimage.jpg',
          category_id: 'car_electronics',
          quantity: 1,
          currency_id: null,
          unit_price: 5000,
        },
      ],
      payment_methods: getPaymentMethodsPayload(formData),
      shipments: {
        free_methods: [{}],
        receiver_address: {},
      },
      back_urls: {},
      differential_pricing: {},
      metadata: {},
      installments: maxInstallments || 1,
    };

    (async () => {
      const preferenceData = await PreferencesService.postPreferences(
        accessToken,
        customPreferenceData,
      );
      preferenceId = preferenceData;
      iframeRef.current.src = preferenceData.init_point.concat(
        '&device-override=',
        formData.resolution,
      );

      const preferenceIdExpirationTime = Date.now() + 10 * 60 * 60 * 1000;
      localStorage.setItem(
        'cho-pro-preferenceData',
        JSON.stringify(preferenceData),
      );
      localStorage.setItem(
        'cho-pro-preferenceIdExpiration',
        preferenceIdExpirationTime,
      );

      localStorage.setItem('cho-pro-accessToken', accessToken);

      const props = createCheckoutProProps();

      setCheckoutProPropsAndEval(props, checkoutProCreationScript, 1000);
    })();
  }, [
    publicKey,
    theme,
    maxInstallments,
    showTitle,
    showPaymentButton,
    language,
    customVariables,
    customTexts,
    payerInfo,
    amount,
    formData.resolution,
    ...debouncePaymentMethods,
  ]);

  React.useEffect(() => {
    const mpScript = document.createElement('script');
    mpScript.src = 'https://sdk.mercadopago.com/js/v2';
    document.body.appendChild(mpScript);

    return () => {
      document.body.removeChild(mpScript);
    };
  }, []);

  return (
    <>
      <div id="checkout-pro_container" />
      <div className="checkout-pro-receptor__container">
        <iframe
          className="checkout-pro-receptor"
          ref={iframeRef}
          allowfullscreen
        />
      </div>
    </>
  );
};

module.exports = View;
